"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FeIconStack = _interopRequireDefault(require("./FeIconStack"));

var _FeIcon = _interopRequireDefault(require("./FeIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeLoader = function FeLoader(_ref) {
  var feSize = _ref.feSize,
      label = _ref.label,
      isLabelInline = _ref.isLabelInline,
      className = _ref.className;
  var classNames = (0, _classnames.default)({
    'fe-compact-spinner': isLabelInline,
    'fe-stacked-spinner': !isLabelInline
  }, className);
  var spinnerClass = "fe-spinner fe-spinner--".concat(feSize);
  return _react.default.createElement("div", {
    className: classNames
  }, _react.default.createElement(_FeIconStack.default, {
    className: spinnerClass
  }, _react.default.createElement(_FeIcon.default, {
    family: "regular",
    icon: "circle",
    className: "fe-spinner__circle"
  }), _react.default.createElement(_FeIcon.default, {
    family: "regular",
    icon: "spinner-third",
    className: "fe-spinner__circle",
    spin: true
  })), label && _react.default.createElement("span", {
    className: "caption"
  }, label));
};

FeLoader.defaultProps = {
  feSize: 'l',
  label: null,
  isLabelInline: false
};
FeLoader.propTypes = {
  /** Provide size for loader*/
  feSize: _propTypes.default.oneOf(['xxl', 'xl', 'l', 'sm']),

  /** Provide label for loader*/
  label: _propTypes.default.string,

  /** Set true/false to change inline label*/
  isLabelInline: _propTypes.default.bool
};
FeLoader.displayName = 'FeLoader';
var _default = FeLoader;
exports.default = _default;